/** Slow subpixel drift at 6 fps also stays outside the demand monitor's
 * continuous-frame window (120 ms), so ambience never lowers the quality tier. */
export function startShaftDustAnimation(invalidate: () => void): () => void {
	const motion = window.matchMedia?.("(prefers-reduced-motion: reduce)");
	let timer: ReturnType<typeof setInterval> | undefined;
	const sync = () => {
		if (timer !== undefined) clearInterval(timer);
		timer = undefined;
		if (document.visibilityState !== "hidden" && !motion?.matches) {
			timer = setInterval(invalidate, 1000 / 6);
		}
	};
	document.addEventListener("visibilitychange", sync);
	motion?.addEventListener("change", sync);
	sync();
	return () => {
		if (timer !== undefined) clearInterval(timer);
		document.removeEventListener("visibilitychange", sync);
		motion?.removeEventListener("change", sync);
	};
}
